import React from "react";

function sortedDivision(standings, division) {
  return standings.filter((site) => String(site.division || "gold").toLowerCase() === division);
}

export default function PromotionZone({ standings = [], season }) {
  const promotionPlaces = Math.max(0, Number(season?.promotionPlaces || 1));
  const relegationPlaces = Math.max(0, Number(season?.relegationPlaces || 1));
  const silver = sortedDivision(standings, "silver");
  const gold = sortedDivision(standings, "gold");
  const promoted = silver.slice(0, promotionPlaces);
  const relegated = relegationPlaces ? gold.slice(-relegationPlaces) : [];
  const promotionGap = promoted.length && silver[promotionPlaces]
    ? Math.abs(Number(promoted[promoted.length - 1].points || 0) - Number(silver[promotionPlaces].points || 0)) : 0;
  const firstRelegatedIndex = gold.length - relegationPlaces;
  const relegationGap = relegated.length && gold[firstRelegatedIndex - 1]
    ? Math.abs(Number(relegated[0].points || 0) - Number(gold[firstRelegatedIndex - 1].points || 0)) : 0;

  return <section className="league-promotion-grid">
    <article className="league-zone-card promotion"><span>Silver League promotion line · {promotionGap} point gap</span><h3>Promotion to Gold League</h3>{promoted.length ? promoted.map((site, index) => <div key={site.id}><b>{index + 1}</b><strong>{site.name}</strong><em>{site.points} pts</em></div>) : <p>No Silver League sites available.</p>}</article>
    <article className="league-zone-card relegation"><span>Gold League pressure line · {relegationGap} point gap</span><h3>Relegation to Silver League</h3>{relegated.length ? relegated.map((site) => <div key={site.id}><b>{gold.indexOf(site) + 1}</b><strong>{site.name}</strong><em>{site.points} pts</em></div>) : <p>No Gold League sites available.</p>}</article>
  </section>;
}
